import { Card, Typography } from "@mui/material";
import React from "react";
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  ResponsiveContainer,
  XAxis,
} from "recharts";
import LineWithArrows from "./LineWithArrows";
import { fontSizes } from "../../../theme";
import { useApp } from "../../../contexts/AppContext";

interface DataItem {
  range: string;
  value: number;
}

const data: DataItem[] = [
  { range: "0-25", value: 2 },
  { range: "25-50", value: 5 },
  { range: "50-75", value: 4 },
  { range: "75-100", value: 3 },
];

const COLORS = ["#F3E29B", "#F3B17D", "#C1B6F5", "#C5DEA8"];

const Distribution: React.FC<{ eggs: number[] }> = ({ eggs }) => {
  const data: DataItem[] = [
    { range: "0-25", value: eggs.filter((e) => e >= 0 && e <= 25).length },
    { range: "25-50", value: eggs.filter((e) => e > 25 && e <= 50).length },
    { range: "50-75", value: eggs.filter((e) => e > 50 && e <= 75).length },
    { range: "75-100", value: eggs.filter((e) => e > 75 && e <= 100).length },
  ];
  const { translate } = useApp();

  const renderCustomizedLabel = (props: any) => {
    const { x, y, width, height, value } = props;
    const radius = 10;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y - radius - 35}
          fill="#78716C"
          textAnchor="middle"
          fontWeight={"bold"}
          dominantBaseline="middle"
        >
          {value}
        </text>
        <text
          x={x + width / 2}
          y={y - radius - 10}
          fill="#78716C"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {translate("general", "oocyte")}
        </text>
      </g>
    );
  };

  return (
    <Card
      sx={{ padding: 2, border: "1px solid #e0e0e0", borderRadius: 2 }}
      id="distribution-chart"
    >
      <Typography variant="medium" fontSize={fontSizes.lg}>
        {translate("oocyte", "report.distribution.title")}
      </Typography>

      <ResponsiveContainer width="100%" height={450}>
        <BarChart
          data={data}
          margin={{ top: 60, right: 30, left: 20, bottom: 20 }}
        >
          <XAxis
            strokeWidth={0}
            dataKey="range"
            tick={{ fontWeight: "bold" }}
            dy={10}
          />
          <Bar
            dataKey="value"
            fill="#00a0fc"
            strokeWidth={1}
            radius={[15, 15, 15, 15]}
          >
            <LabelList
              dataKey="value"
              position={"top"}
              content={renderCustomizedLabel}
            />
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % 4]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <LineWithArrows
        rightLabel={translate("oocyte", "report.distribution.rightLabel")}
        leftLabel={translate("oocyte", "report.distribution.leftLabel")}
      />
    </Card>
  );
};

export default Distribution;
